import {format} from 'date-fns';
import {t} from '../common/getTranslations';
import {getAutoSaveRecentKeyword} from './autoSaveRecentKeyword.storage';
import {RECENT_KEYWORD_LIST_MAX_LENGTH} from './constant';

export interface RecentSearchKeyword {
  keyword: string;
  /** MM.DD */
  createdAt: string;
}

/**
 * 중복 없이 10개 이하의 키워드 리스트를 저장합니다.
 */
export function addRecentKeyword(keyword: string) {
  if (!getAutoSaveRecentKeyword()) {
    return;
  }
  const createdAt = format(new Date(), t('date_formatter_year_less_dot'));
  const newList = getAddedRecentKeywordList({
    recentKeywordList: getRecentKeywordList(),
    keyword,
    createdAt,
  });

  window.localStorage.setItem(
    LOCAL_STORAGE_KEY_RECENT_SEARCH_KEYWORD_LIST,
    JSON.stringify(newList)
  );
}

export function getAddedRecentKeywordList({
  recentKeywordList,
  keyword,
  createdAt,
}: {
  recentKeywordList: RecentSearchKeyword[] | null;
  keyword: string;
  createdAt: string;
}) {
  if (!recentKeywordList || !recentKeywordList.length) {
    return [{keyword, createdAt}];
  }

  const newList = recentKeywordList.filter(item => item.keyword !== keyword);
  newList.unshift({keyword, createdAt});
  return newList.length > RECENT_KEYWORD_LIST_MAX_LENGTH
    ? newList.slice(0, RECENT_KEYWORD_LIST_MAX_LENGTH)
    : newList;
}

export function getRecentKeywordList() {
  const list = window.localStorage.getItem(
    LOCAL_STORAGE_KEY_RECENT_SEARCH_KEYWORD_LIST
  );
  return list ? (JSON.parse(list) as RecentSearchKeyword[]) : [];
}

export function clearRecentKeywordList() {
  window.localStorage.removeItem(LOCAL_STORAGE_KEY_RECENT_SEARCH_KEYWORD_LIST);
}

export function removeRecentKeyword(keyword: string) {
  const list = getRecentKeywordList();
  if (!list) {
    return;
  }

  const newList = list.filter(item => item.keyword !== keyword);
  window.localStorage.setItem(
    LOCAL_STORAGE_KEY_RECENT_SEARCH_KEYWORD_LIST,
    JSON.stringify(newList)
  );
}

const LOCAL_STORAGE_KEY_RECENT_SEARCH_KEYWORD_LIST =
  'recent_search_keyword_list';
